import TrainReport from "./trainReport/trainReport";
import ReportConfigList from "./reportConfig/reportConfigList";
import TableConfigList from "./tableConfig/tableConfigList";
import ReportConfigDetailList from "./reportConfig/reportConfigDetail/index";
import TableFieldList from "./tableConfig/tableField/tableFieldList";
import TableFieldDetail from "./tableConfig/tableField/tableFieldDetail/tableFieldDetail";
import ReportConfigForm from './reportConfig/reportConfigForm';

export {
  TrainReport,
  TableConfigList,
  ReportConfigList,
  ReportConfigDetailList,
  TableFieldList,
  TableFieldDetail,
  ReportConfigForm
}
